import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AlertComponent } from 'src/app/shared/components/alert/alert.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

  constructor(private _router: Router,
    private _modalService: NgbModal) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        tap(
          event => {
            if (event instanceof HttpResponse) {
            }
          },
          error => {
            console.log(error)

            const excluirAlertGlobal = request.url.includes('/reabastos/') || request.url.includes('consultar-orden'); // SUMMIT FASE 1
            if (excluirAlertGlobal) {
              return;
            }

            const modalRef = this._modalService.open(AlertComponent, {
              backdrop: 'static',
              keyboard: false,
              centered: true
            });
            if (error.status == 0) {
              modalRef.componentInstance.title = 'Alerta!';
              modalRef.componentInstance.text = 'El servidor no responde';
            } else if (error.status == 400) {
              modalRef.componentInstance.title = 'Alerta!';
              modalRef.componentInstance.text = error.error.message;
            } else if (error.status == 401) {
              localStorage.clear();
              this._router.navigateByUrl('/auth/login');
              modalRef.componentInstance.title = 'Alerta!';
              let msg = error.error.MensajeError ? error.error.MensajeError : 'Vuelva a ingresar por favor.';
              modalRef.componentInstance.text = 'Acceso denegado: ' + msg;
            } else if (error.status == 500){
              modalRef.componentInstance.title = 'Alerta genera guía!';
              // modalRef.componentInstance.text = error.statusText;
              modalRef.componentInstance.text = error.error.message;
            } else {
              modalRef.componentInstance.title = 'Alerta!';
              // modalRef.componentInstance.text = error.statusText;
              modalRef.componentInstance.text = error.error.message;
            }
          })
      )
  }
}
